import React, { useState, useEffect } from 'react';
import { Alert, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from 'react-redux';
import { type RootState } from 'store/rootReducer';
import { setShowFlexTokenExpiry } from 'store/notifications';

const NotificationBanner = (): JSX.Element => {
  const dispatch = useDispatch();
  const { showFlexTokenExpiry, flexTokenExpiryDays } = useSelector(
    (state: RootState) => state.notifications,
  );

  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(showFlexTokenExpiry);
  }, [showFlexTokenExpiry]);

  if (!open) return null;

  return (
    <Box
      position="fixed"
      top={72}
      width="82vw"
      zIndex={1300}
      style={{ display: 'content' }}
    >
      <Alert
        style={{ height: '35px' }}
        severity="warning"
        variant="filled"
        sx={{
          height: '35px',
          py: 0.5,
          pl: '36px',
          alignItems: 'center',
          '& .MuiAlert-icon': {
            fontSize: 18,
            mr: 1,
            mt: 0.2,
          },
          '& .MuiAlert-message': {
            paddingTop: 1,
            fontSize: 12,
          },
        }}
        action={
          <IconButton
            style={{ padding: '2px 0' }}
            color="inherit"
            size="small"
            onClick={() => {
              dispatch(setShowFlexTokenExpiry(false));
            }}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
      >
        {`Your Interactive Brokers flex token will expire in ${flexTokenExpiryDays} days. Please renew it before it expires.`}
      </Alert>
    </Box>
  );
};

export default NotificationBanner;
